
// import {md5} from "md5js"
import {url} from "./url.js"

class requestSign{
  signIntance=null;
  queue=[];
  tctimestamp=""
  /***
   * 构建签名对象
   * @param url 获取签名key\value的url
   * @param methods 请求方式
   * @param questTool 使用的请求工具
   */
  constructor(options){
    this.url=url;
    this.NOLOAD=0//Symbol();
    this.LOADING=1//Symbol();
    this.LOADED=2//Symbol();
    this.INVALID=3//Symbol();
    this.STATUS=this.NOLOAD;//this.NOLOAD;

    this.config={
      url:this.url.api.curinfo,
      method:"get",
      questTool:null,
      baseUrl: this.url.signDomain
    };

    this.tctimestamp=(new Date()).getTime();

    if(options){
      this.config=Object.assign({},this.config,options)
    }
    // this.md5=md5;
  }
  //创建签名 获取签名key\val
  createSign(){
    let self=this;
    this.STATUS=this.LOADING
    this.config.questTool[this.config.method]({
      url:this.config.url,
      baseURL:this.config.baseUrl,
      needSign:false,
      customCodeHandlers:{

      },
      success:(res)=>{
        self.STATUS=self.LOADED
        // console.log(res,"签名")
        // console.log(res,"sign-----------")
        self.signIntance=res.data.response.result;
        while(self.queue.length>0){
          let fn=self.queue.shift();
          if(fn){
            fn();
          }
        }

      }
    })
  }
  getString(obj){
    if(Object.prototype.toString.call(obj)=="[object Array]"){
      return JSON.stringify(obj)
    }else if(Object.prototype.toString.call(obj)=="[object Object]"){
      return JSON.stringify(obj)
    }else if(Object.prototype.toString.call(obj)=="[object String]") {
      return obj
    }else if(Object.prototype.toString.call(obj)=="[object Number]"){
        return obj
      }
  }


  getUrlParams(url) {
    try {
      var index = url.indexOf('?');
      url = url.match(/\?([^#]+)/)[1];
      var obj = {}, arr = url.split('&');
      for (var i = 0; i < arr.length; i++) {
        var subArr = arr[i].split('=');
        //--
        let _index=arr[i].indexOf("=");
        let key=arr[i].substring(0,_index);
        let val=arr[i].substring(_index+1)
        obj[key]=val;
      }
      return obj;

    } catch (err) {
      return null;
    }
  }

  signGet(url,callback){

    let parmJson=this.getUrlParams(url);
    parmJson=parmJson?parmJson:{};
    if(parmJson){
      this.signData(parmJson,(tctimestamp,tcsign)=>{
        var _url=url;
        if(_url.indexOf("?")==-1){
          _url=_url+"?"
        }
        _url=_url+"&tctimestamp="+tctimestamp+"&kv="+this.signIntance.kv+"&tcsign="+tcsign
        _url=_url.replace("?&","?")
        callback(_url)
      })
    }

  }
  signPost(data,callback){
    this.signData(data,(tctimestamp,tcsign)=>{
      let _data=data;
      if(typeof(data) == "string"){
        _data=JSON.parse(data);
        _data.tctimestamp=tctimestamp;
        _data.tcsign=tcsign;
        _data.kv=this.signIntance.kv;
        _data=JSON.stringify(_data)
      }else{
        _data.tctimestamp=tctimestamp;
        _data.tcsign=tcsign;
        _data.kv=this.signIntance.kv;
      }
      callback(_data)
    })
  }
  signData(data,callback) {
    let _callback=()=>{
      let keys = Object.keys(data).sort();

      let _data;
      if(keys.length>0){

        _data=[]

        keys.forEach((item,index,arr)=>{
          if(data[item]===null||data[item]===""){
            return
          }
          _data.push(item+"="+this.getString(data[item]))

        })

        if(_data.length>0){
          _data=_data.join("&")
        } else {
          _data=""
        }


      }



      //kv+tctimestamp 构建有序请求
      if(_data){
        _data=_data+"&kv="+this.signIntance.kv+"&tctimestamp="+this.tctimestamp+this.signIntance.key;
      }else{
        _data="kv="+this.signIntance.kv+"&tctimestamp="+this.tctimestamp+this.signIntance.key;
      }

      // console.log(_data,"拼接后即将md5签名的参数")
      //kv+tctimestamp+key md5加密
      var sign=window.md5(_data);
      // console.log(this.md5(_data,32),"npm md5")
      // console.log(sign,"window.md5")

      //回传
      callback(this.tctimestamp,sign);
    }

    if (!this.signIntance) {
      // console.log("----------------------a888")
      this.queue.push(_callback)
      if(this.STATUS==this.NOLOAD||this.STATUS==this.INVALID){
        this.createSign();
      }
    }else{
      _callback();
    }

  }
}

export {
  requestSign
}



// WEBPACK FOOTER //
// ./static/js/lib/requestSign.js